import { Component, OnInit } from '@angular/core';
import { ApiConnectorService } from '../../_LOGIC/__api/api-connector.service';
import { GuiFlowManagerService } from '../../_LOGIC/__gui/gui-flow-manager.service';

@Component({
  selector: 'app-our-offer',
  templateUrl: './our-offer.component.html',
  styleUrls: ['./our-offer.component.css']
})
export class OurOfferComponent implements OnInit {
  servicesVisible = false;
  packsVisible = true;
  loading = false;
  selector = 'packs';

  descriptionVisible = false;
  selectedCategory = 'Estudios';

  categories = ['Estudios','Trabajo','Turismo'];

  products = [];

  constructor(private guiFlow: GuiFlowManagerService,private apiConnector: ApiConnectorService) { }

  ngOnInit(): void {
    this.getComponentData();
  }

  addItem(item){
    /* this.shoppingCartManager.addItemToCart(item); */
    /* this.guiFlow.showNotificationMessage('Añadido al carrito de compras'); */
  }
  saveDataToLocalClass(data: any) {
    this.products = data.records;
    this.loading = false;
  }

  getComponentData() {
    this.loading = true;
    if(this.products.length==0){
      this.apiConnector.simpleQueryId('get','product', null,null,null,null)
    .subscribe(response => this.saveDataToLocalClass(response));
    }
  }

  getProductsByCategory(category){
    let res = [];
    for(let prod of this.products){
      if(prod.category == category){
        res.push(prod);
      }
    }
    return res;
  }

  showHidePacks(){
    this.selector == 'packs';
  }

  showHideService(){
    this.selector = 'services';
  }

  test(value){
    this.selectedCategory = value.tab.textLabel;
  }

  changedTab(event){
    switch(event){
      case 0:
        this.selectedCategory = null;
        this.selectedCategory = 'Estudios';
        break;
      case 1:
        this.selectedCategory = null;
        this.selectedCategory = 'Trabajo';
        break;
      case 2:
        this.selectedCategory = null;
        this.selectedCategory = 'Turismo';
        break;
      case 3:
        this.selectedCategory = 'Turismo';
        break;
      default:
        this.selectedCategory = 'Todas';
    }
  }
}
